import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#11243A] text-white pt-16 pb-8" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-32">
          {/* Brand & Contact */}
          <div data-id="element-33">
            <div className="mb-6" data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/8s4d9srHFAq5QBzYs3roqy/logo-2023-d.png" alt="BLC Custom Homes, Inc" className="h-12 w-auto brightness-0 invert" data-id="element-35" />
            </div>
            <div className="space-y-3 text-gray-300" data-id="element-36">
              <p data-id="element-37">7081 N. Marks</p>
              <p data-id="element-38">Fresno, CA 93711</p>
              <p className="pt-2" data-id="element-39">
                <a href="tel:559-288-0499" className="hover:text-brand-orange transition-colors font-semibold text-white" data-id="element-40">
                  559-288-0499
                </a>
              </p>
              <p data-id="element-41">
                <a href="mailto:info@blccustomhomes.com" className="hover:text-brand-orange transition-colors" data-id="element-42">
                  info@blccustomhomes.com
                </a>
              </p>
              <p className="pt-4 text-brand-orange font-medium" data-id="element-43">
                CA License #947943
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-44">
            <h4 className="text-lg font-semibold mb-6" data-id="element-45">Quick Links</h4>
            <ul className="space-y-3" data-id="element-46">
              {['Home', 'Services', 'Gallery', 'About', 'Blog', 'Free Quote'].map(link => <li key={link} data-id="element-47">
                  <a href={`#${link.toLowerCase().replace(' ', '-')}`} className="text-gray-300 hover:text-brand-orange transition-colors" data-id="element-48">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-49">
            <h4 className="text-lg font-semibold mb-6" data-id="element-50">Our Services</h4>
            <ul className="space-y-3" data-id="element-51">
              <li data-id="element-52">
                <a href="#kitchens" className="text-gray-300 hover:text-brand-orange transition-colors" data-id="element-53">
                  Kitchen Remodeling
                </a>
              </li>
              <li data-id="element-54">
                <a href="#bathrooms" className="text-gray-300 hover:text-brand-orange transition-colors" data-id="element-55">
                  Bathroom Remodeling
                </a>
              </li>
              <li data-id="element-56">
                <a href="#additions" className="text-gray-300 hover:text-brand-orange transition-colors" data-id="element-57">
                  Home Additions
                </a>
              </li>
              <li data-id="element-58">
                <a href="#custom-homes" className="text-gray-300 hover:text-brand-orange transition-colors" data-id="element-59">
                  Custom Homes
                </a>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-60">
            <h4 className="text-lg font-semibold mb-6" data-id="element-61">Service Areas</h4>
            <ul className="space-y-3 text-gray-300" data-id="element-62">
              <li data-id="element-63">Fresno</li>
              <li data-id="element-64">Clovis</li>
              <li data-id="element-65">Fresno County</li>
              <li data-id="element-66">Madera County</li>
              <li data-id="element-67">Tulare County</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400" data-id="element-68">
          <p data-id="element-69">© {currentYear} BLC Custom Homes Inc. All rights reserved.</p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-70">
            <a href="#privacy" className="hover:text-white transition-colors" data-id="element-71">
              Privacy Policy
            </a>
            <a href="#terms" className="hover:text-white transition-colors" data-id="element-72">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}